<template>
  <div
    id="trainee-registration-recycle-modal"
    class="modal fade"
    data-backdrop="static"
    tabindex="1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content modal-borderless">
        <ValidationObserver ref="observer">
          <form>
            <div class="modal-header">
              <h4 class="modal-title">
                {{
                  $tc("registerTrainee", traineesNumber, {
                    count: traineesNumber,
                  })
                }}
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click.stop.prevent="hideModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-lg-4">
                  {{ $t("selectTraining") }}
                </div>
                <div class="col-12 mb-4">
                  <div class="post__date mt-2">
                    {{ courses.length }} {{ $t("trainingsMatch") }}
                  </div>
                </div>
                <div class="col-12" v-if="courses.length">
                  <courseItem
                    v-for="(item, index) in courses"
                    :course="item"
                    :index="index"
                    :key="index"
                    :selectedTraining="selectedTraining"
                  />
                </div>
                <div class="col-12" v-else>
                  <div class="text-center">
                    <div class="alert alert-primary">
                      {{ $t("recycledTraininigEmpty") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="text-center" v-if="showAlert">
                    <div class="alert alert-primary">
                      {{ $t("noTrainingExist") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="sessions.length">
                <div class="col-12 col-lg-4">
                  {{ $t("selectSession") }}
                </div>
                <div class="col-12 mb-4">
                  <div class="post__date mt-2">
                    {{ sessions.length }} {{ $t("sessionsMatch") }}
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <sessions-row
                    v-for="(item, index) in sessions"
                    :key="index"
                    :session="item"
                    :index="index"
                    :selectedSession="selectedSession"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3" v-if="selectedSession">
                  <div class="text-danger small">
                    {{
                      $t("registrationWarningP1", traineesNumber, {
                        traineesNumber: traineesNumber,
                      })
                    }}
                    {{
                      $t("registrationWarningP2", selectedTraining.name, {
                        selectedTrainingName: selectedTraining.name,
                      })
                    }}
                  </div>
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div class="">
                        <div class="" :class="alert.type" v-show="alert.on">
                          {{ alert.text }}
                        </div>
                      </div>
                      <button
                        class="btn btn-primary"
                        @click.prevent.stop="registerTrainee"
                        :disabled="isSaving || !selectedTraining || !selectedSession"
                      >
                        {{
                          $tc("registerTraineeBtn", traineesNumber, {
                            count: traineesNumber,
                          })
                        }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="modal-footer d-flex flex-wrap justify-content-between"
            ></div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { lazyInput } from "vue-lazy-input";
import { mapFields } from "vuex-map-fields";
import SessionsRow from "./SessionsRow.vue";
import CourseItem from "./CourseItem.vue";
export default {
  name: "RecycleTraineeModal",
  components: { SessionsRow, CourseItem },
  directives: {
    lazyInput,
  },
  data() {
    return {
      isLoaded: false,
      q: "",
      isAllSelected: false,
      trainees: [],
      total: 0,
      traineeLang: "FR",
      selectedTraining: null,
      habilitationCode: null,
      segment: null,
      courses: [],
      showAlert: false,
      selectedSession: null,
      isSaving: false,
      alert: {
        on: false,
        type: "",
        text: "",
      },
    };
  },
  computed: {
    ...mapFields(["user", "company", "establishment"]),
    traineesNumber() {
      return this.total;
    },
    sessions() {
      if (this.selectedTraining) {
        return this.selectedTraining.sessions.data;
      }
      return [];
    },
  },
  created() {},
  mounted() {
    this.$bus.$on("update-selected-training", (course) => {
      this.selectedTraining = course;
      this.selectedSession = null;
    });
    this.$bus.$on("update-selected-session", (session) => {
      this.selectedSession = session;
    });
    this.$bus.$on("trainee-registration-recycle-modal.show", (data) => {
      this.trainees = data.traineesIds;
      this.isAllSelected = data.isAllSelected;
      this.total = data.total;
      this.segment = data.segment;
      this.habilitationCode = data.habilitationCode;
      this.courses = data.courses;
      this.showModal();
    });
    this.$bus.$on("hide-trainee-registration-recycle-modal", () => {
      this.hideModal();
    });
    this.isLoaded = true;
  },
  beforeDestroy() {
    //do something before destroying vue instance
    this.$bus.$off("trainee-registration-recycle-modal.show");
  },
  methods: {
    showModal() {
      setTimeout(() => {
        $("#trainee-registration-recycle-modal").modal("show");
      }, 500);

      // $("#trainee-registration-recycle-modal").modal("show");
    },
    hideModal() {
      this.q = "";
      this.selectedSession = null;
      this.setSelectedTraining(null, 1);
      this.courses = [];
      this.$refs.observer.reset();
      $("#trainee-registration-recycle-modal").modal("hide");
    },
    // registerTrainee() {
    //   this.isSaving = true;
    //   let priceCource = this.$lodash.get(
    //     this.selectedTraining,
    //     "offers.data.price",
    //     0
    //   );
    //   let trainees = [];
    //   let data = {
    //     traineesIds: this.trainees,
    //   };
    //   this.$store.dispatch("monitoring/getTraineesInfo", data).then((resp) => {
    //     trainees = resp;

    //     let order = [
    //       {
    //         clientId: this.user.id,
    //         courseId: this.selectedTraining.id,
    //         sessionId: this.selectedSession.id,
    //         trainees: trainees,
    //         qty: this.selectedTraining.length,
    //         price: priceCource,
    //         priceIATA: this.selectedTraining.priceIATA,
    //       },
    //     ];
    //     let locale = document.head.querySelector(
    //       'meta[name="app-locale"]'
    //     ).content;
    //     let payload = {
    //       token: "",
    //       clientId: this.user.id,
    //       local: locale,
    //       orderItems: order,
    //       payment: {},
    //       orderWfsa: true,
    //     };
    //     console.log("payload add order = ", payload);
    //     this.$store
    //       .dispatch("addOrder", payload)
    //       .then((response) => {
    //         let trainee = null;
    //         if (this.isAllSelected) {
    //           trainee = "All";
    //         } else {
    //           trainee = this.trainees;
    //         }
    //         let data = {
    //           clientId: this.user.id,
    //           sessionId: this.selectedSession.id,
    //           trainees: trainee,
    //         };

    //         this.$store
    //           .dispatch("trainees/registerTrainee", data)
    //           .then((response) => {
    //             this.alert.on = true;
    //             this.alert.text = this.$t("registerTraineeSuccess");
    //             this.alert.type = "text-success";
    //             setTimeout(() => {
    //               this.alert.on = false;
    //               this.alert.text = "";
    //               this.alert.type = "";
    //               this.hideModal();
    //             }, 5000);
    //           });
    //       })
    //       .finally(() => {
    //         this.isSaving = false;
    //       });
    //   });
    // },
    registerTrainee() {
      this.isSaving = true;
      let data = {
        clientId: this.user.id,
        sessionId: this.selectedSession.id,
        trainees: this.trainees,
        companyId: this.company.id,
        establishmentId: this.establishment.id,
        clientWfsa: true,
      };
      this.isSaving = true;
      this.$store
        .dispatch("trainees/registerTrainee", data)
        .then((response) => {
          this.alert.on = true;
          this.alert.text = this.$t("registerTraineeSuccess");
          this.alert.type = "text-success";
          setTimeout(() => {
            this.alert.on = false;
            this.alert.text = "";
            this.alert.type = "";
            this.hideModal();
          }, 5000);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    setSelectedTraining(training, index) {
      this.selectedTraining = training;
      this.selectedSession = null;
    },
    clearSelectedTraining() {
      this.selectedTraining = null;
      this.selectedSession = null;
    },
    formatDate(date, format = "YYYY.MM.DD") {
      if (date && this.$moment(date).isValid()) {
        return this.$moment(date).format(format);
      } else return false;
    },
  },
};
</script>

<style></style>
